export enum PaymentThroughEnum {
  MYFATOORAH = "MYFATOORAH",
  IN_APP_PURCHASE_APPLE = "IN_APP_PURCHASE_APPLE",
  IN_APP_PURCHASE_GOOGLE = "IN_APP_PURCHASE_GOOGLE",
  OTHER = "OTHER",
}
